module.exports = require("./pt-GQ");